.graphic-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.graphic-container > img {
    width: 100%;
}

.graphic-container > svg {
    width: 90%;
}
